import EnterFlowAccountForm from 'components/authentication/EnterFlowAccountForm';
import { FadeIn } from 'components/common/FadeIn';
import { useScrollToElement } from 'hooks/useScrollToElement';
import { useRouter } from 'next/router';
import React, { useRef } from 'react';
import Checkout from '../Checkout';
import MembershipSummary from '../MembershipSummary';
import TitleSection from '../TitleSection';
import { enterFlowSubtitle, enterFlowTitle } from '../V2/V2EntriesAndDays';
import styles from './V1CheckoutAndIdentity.module.css';
import V1EnterLayout from './V1EnterLayout';

interface V1CheckoutAndIdentityProps {}

export const V1CheckoutAndIdentity: React.FC<
  V1CheckoutAndIdentityProps
> = ({}) => {
  const router = useRouter();
  const checkoutComponentMarker = useRef<HTMLDivElement>(null);
  const scroller = useScrollToElement(checkoutComponentMarker);
  const title = enterFlowTitle(true);
  const subtitle = enterFlowSubtitle(true);

  const login = (
    <EnterFlowAccountForm
      completionHandler={async () => {
        checkoutComponentMarker.current &&
          scroller.requestScroll({
            ensureAtTopOfViewport: true,
          });
      }}
      appleRedirectPath={router.pathname}
      slidingModalSlideAmount="static"
    />
  );

  return (
    <V1EnterLayout
      desktopLeft={
        <>
          <TitleSection title={title} subtitle={subtitle} showInfoGraphic />
          <FadeIn onScroll>{login}</FadeIn>
          <FadeIn onScroll>
            <Checkout />
          </FadeIn>
        </>
      }
      desktopRight={
        <>
          <MembershipSummary checkoutPage onLightBackground showMascot />
        </>
      }
      mobileView={
        <>
          <TitleSection title={title} subtitle={subtitle} showInfoGraphic />
          <div className={styles.mobileViewWrapper}>
            <MembershipSummary
              checkoutPage
              onLightBackground
              hideSummaryItemsByDefault
            />
            {login}
            <div ref={checkoutComponentMarker}></div>
          </div>
          <Checkout />
        </>
      }
    />
  );
};

export default V1CheckoutAndIdentity;
